import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import ToastPlugin from 'vue-toast-notification';
import bottomNavigationVue from "bottom-navigation-vue";
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "bootstrap"
import "./assets/font.css"
import "./assets/css/custom.css"
import "./assets/css/fontawesome.css"
import "./assets/css/all.css"
import i18n from './i18n';
window.$ = window.jQuery = require('jquery');

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .use(ToastPlugin)
  .use(i18n)
  .use(bottomNavigationVue)
  .mount('#app')
